import React from 'react'
import { IconProps } from '../../../common/types'

const InvoicesIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M19 20.688H5a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1m2 13a2 2 0 0 1-2-2v-11m2 13a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-2m-4-3H9m-2 12h6m-6-8h6v4H7z"
      ></path>
    </svg>
  )
}

export default InvoicesIcon
